/* ============================================================
   Brick Box — website forms into Google Sheets

   Any <form data-bb-lead="<form id>" data-leads-url="<web app URL>"> is picked up here.

     - Normal forms (Contact Us): the page does not reload. The answer from the sheet
       endpoint decides the message, so a lead is never reported as sent when it was not.
     - Passive forms (data-bb-lead-passive, e.g. the footer newsletter that Shopify itself
       processes): the form submits as usual and a copy goes to the sheet in the background.

   The endpoint is a Google Apps Script web app (see design/forms-sheets.md); each form id
   lands in its own spreadsheet. A hidden field named "website" is a honeypot for bots.
   ============================================================ */
(function brickboxLeads() {
  'use strict';

  const FIELD_NAME = /^[a-z_]+\[([a-z_]+)\]$/i;

  function collect(form, formId) {
    const body = new URLSearchParams();
    body.set('form', formId);
    for (const field of form.elements) {
      if (!field.name || field.disabled) continue;
      if (field.type === 'file' || field.type === 'submit' || field.type === 'button') continue;
      if ((field.type === 'checkbox' || field.type === 'radio') && !field.checked) continue;
      const match = FIELD_NAME.exec(field.name);
      const key = match ? match[1] : field.name;
      if (key === 'form' || key === 'tags') continue;
      body.set(key, field.value);
    }
    body.set('page', location.pathname);
    return body;
  }

  function status(form) {
    return form.querySelector('[data-bb-lead-status]');
  }

  function say(form, message, ok) {
    const holder = status(form);
    if (!holder) return;
    holder.hidden = false;
    holder.textContent = message;
    holder.dataset.state = ok ? 'ok' : 'error';
  }

  async function sendAndWait(url, body) {
    const response = await fetch(url, { method: 'POST', body });
    const result = await response.json();
    return result && result.ok === true;
  }

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest ? event.target.closest('form[data-bb-lead]') : null;
    if (!form) return;

    const url = form.getAttribute('data-leads-url');
    const formId = form.getAttribute('data-bb-lead');
    if (!url) {
      if (!form.hasAttribute('data-bb-lead-passive')) {
        event.preventDefault();
        say(form, form.getAttribute('data-unavailable') || 'This form is not available right now.', false);
      }
      return;
    }

    const body = collect(form, formId);

    if (form.hasAttribute('data-bb-lead-passive')) {
      try {
        fetch(url, { method: 'POST', mode: 'no-cors', keepalive: true, body });
      } catch (error) { /* the form still submits */ }
      return;
    }

    event.preventDefault();
    if (form.getAttribute('aria-busy') === 'true') return;
    if (!form.reportValidity()) return;

    const button = form.querySelector('[type="submit"]');
    form.setAttribute('aria-busy', 'true');
    if (button) button.disabled = true;

    let sent = false;
    try {
      sent = await sendAndWait(url, body);
    } catch (error) {
      sent = false;
    }

    form.removeAttribute('aria-busy');
    if (button) button.disabled = false;

    if (sent) {
      form.reset();
      say(form, form.getAttribute('data-success') || 'Thank you. We will get back to you shortly.', true);
    } else {
      say(form, form.getAttribute('data-failure') || 'Could not send your message. Please try again, or call us.', false);
    }
  });
})();
